import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=107897c5&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=107897c5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107897c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2713853479/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107897c5')) {
      api.createRecord('107897c5', component.options)
    } else {
      api.reload('107897c5', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=107897c5&scoped=true", function () {
      api.rerender('107897c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/BarChart.vue"
export default component.exports